import React from 'react';
import './Button.css';

/**
 * 새로운 통합 버튼 컴포넌트
 * 
 * @param {string} variant - primary, secondary, danger, success, outline-primary, outline-secondary, outline-danger, ghost
 * @param {string} size - sm, md, lg
 * @param {string} icon - 아이콘 문자나 이모지
 * @param {boolean} iconOnly - 아이콘만 표시
 * @param {boolean} disabled - 비활성화
 * @param {boolean} loading - 로딩 상태
 * @param {string} className - 추가 CSS 클래스
 * @param {Function} onClick - 클릭 핸들러
 * @param {ReactNode} children - 버튼 내용
 */
function Button({
  variant = 'primary',
  size = 'md',
  icon,
  iconOnly = false,
  disabled = false,
  loading = false,
  className = '',
  onClick,
  children,
  title,
  ...props
}) {
  // CSS 클래스 조합
  const buttonClasses = [
    'btn',
    `btn-${variant}`,
    `btn-${size}`,
    iconOnly ? 'btn-icon-only' : '',
    loading ? 'btn-loading' : '',
    disabled ? 'btn-disabled' : '',
    className
  ].filter(Boolean).join(' ');

  // 클릭 핸들러
  const handleClick = (e) => {
    if (!disabled && !loading && onClick) {
      onClick(e);
    }
  };

  // 아이콘 렌더링
  const renderIcon = () => {
    if (loading) {
      return <span className="btn-icon">⏳</span>;
    }
    
    if (icon) {
      // 이모지나 특수 문자인 경우
      if (typeof icon === 'string' && icon.length <= 2) {
        return <span className="btn-icon">{icon}</span>;
      }
      
      // SVG 아이콘 매핑
      const iconMap = {
        copy: '📋',
        eye: '👁️',
        eyeOff: '🙈',
        share: '📤',
        trash: '🗑️',
        delete: '🗑️',
        edit: '✏️',
        add: '➕',
        search: '🔍',
        filter: '⚗️',
        sort: '🔤',
        settings: '⚙️',
        logout: '🚪',
        check: '✅',
        x: '❌',
        download: '⬇️',
        upload: '⬆️',
        refresh: '🔄'
      };
      
      return <span className="btn-icon">{iconMap[icon] || icon}</span>;
    }
    
    return null;
  };

  return (
    <button
      type="button"
      className={buttonClasses}
      onClick={handleClick}
      disabled={disabled || loading}
      title={title}
      {...props}
    >
      {renderIcon()}
      {!iconOnly && children && (
        <span className="btn-text">{children}</span>
      )}
    </button>
  );
}

export default Button;
